module.exports = __webpack_public_path__ + "img/logement-espace-exterieur-tres-grand.a7204d05.png";